"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = __importDefault(require("events"));
class ElectronManager extends events_1.default {
    constructor() {
        super();
        try {
            this._isAvailable = DolbyVoice.prototype.hasOwnProperty('setTransparentMode');
        }
        catch (_a) {
            this._isAvailable = false;
        }
    }
    isAvailable() {
        return this._isAvailable;
    }
}
exports.default = ElectronManager;
